module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "value-crud-action--delete"
  }, [_c('modal', {
    attrs: {
      "title": _vm.$t('ui.global.delete_title', {
        name: _vm.model
      }),
      "content": _vm.$t('ui.global.delete_confirmation', {
        name: _vm.item.name
      }),
      "actions": [{
          name: 'valid',
          class: 'btn btn-cancel',
          action: _vm.model + '.delete.confirm'
        },
        {
          name: 'cancel',
          class: 'btn',
          action: _vm.model + '.delete.cancel'
        }
      ],
      "btn-class": "btn btn-tertiary",
      "data-action": _vm.model + '.delete',
      "data-action-id": _vm.item.id
    },
    on: {
      "action": _vm.action
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t("ui.global.unassign")) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1995cac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/CollectionValues/CollectionValueDeleteAction.vue
// module id = 2003
// module chunks = 0